import * as React from 'react'
import { useCarouselData, CarouselSection } from 'hooks'
import ProductRow from '../ProductRow/ProductRow'

const Carousel: React.FC<{
  title: string
  product_id?: string
  locale: string
  section: CarouselSection
  currency: string
  delivery_location: string
}> = ({ title, product_id, locale, section, currency, delivery_location }) => {
  const { products, isLoading } = useCarouselData(
    section,
    currency,
    locale,
    delivery_location,
    product_id
  )

  if (!isLoading && !products?.length) return null

  return <ProductRow title={title} products={products} loading={isLoading} />
}

export default Carousel
